import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import LinearGaugeProps from './LinearGaugeProps'
import KendoLinearGaugePointer from './KendoLinearGaugePointer'

import GaugeArea from '../Common/GaugeArea'
import Scale from './Scale'

export default {
    props: LinearGaugeProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        GaugeArea,
        Scale
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoLinearGauge(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoLinearGauge()
        },
        resolvePointers () {
            this.resolveChildren('pointer', KendoLinearGaugePointer.name)
        },
        _resolveChildren() {
            this.resolvePointers()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoLinearGauge/KendoLinearGaugeMixin.js